import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Tooltip from "./Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "./ValidationMessage";

const CheckBoxWithChild = (props) => {
	const TOOLTIP_LOCKED_TEXT = "Je antwoord is geblokkeerd omdat er reeds bestanden aan de vraag gekoppeld zijn. Indien je alsnog je antwoord wil veranderen moet je eerst alle documenten handmatig verwijderen.";
	const lockedText = props.lockedText ? props.lockedText : TOOLTIP_LOCKED_TEXT;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.validationMessage ? <ValidationMessage validationMessage={props.validationMessage} type={validationMessageType} /> : null;
	const optionList = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	const horizontal = !!props.horizontal;
	const tooltip = props.tooltip ? props.tooltip : "";
	const disabled = props.disabled || props.readonly || props.locked;
	const locked = props.locked ? <Tooltip text={lockedText} icon={types.TOOLTIP_ICON_LOCK} isLocked tooltipType={types.TOOLTIP_INFO} /> : null; //= !!props.locked;
	const optional = !!props.optional;

	let value = false;
	if (props.value != null) {
		if (props.value == false || props.value == "false") {
			value = false;
		} else if (props.value == true || props.value == "true") {
			value = true;
		}
	}

	const child = props.child && (props.value === "true" || props.value == true) ?
		props.child : null;

	const checkboxClassName = classnames({
		"c-input__group": true,
		"disabledCheckbox": props.disabled
	});

	return (
		<div className={"u-clear"}>
			<div key={props.name} className={checkboxClassName}>
				<input type="checkbox" name={props.name} onChange={props.onChange} value={props.value}
					checked={value} id={props.name} disabled={disabled} />
				<label htmlFor={props.name}>{props.label}{locked}</label>
			</div>
			{child}
		</div>
	);
};

CheckBoxWithChild.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	onChange: PropTypes.func.isRequired,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	horizontal: PropTypes.bool,
	labelInside: PropTypes.bool,
	size: PropTypes.number,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	locked: PropTypes.bool,
	lockedText: PropTypes.string,
	optional: PropTypes.bool,
	child: PropTypes.element,
	readonly: PropTypes.bool
};

export default CheckBoxWithChild;
